/**
 * @fileoverview Theme switcher component for toggling between light and dark
 * modes with SSR support.
 */

import * as React from 'react';
import { useTheme } from '@mui/material';
import { PiMoon, PiSun } from 'react-icons/pi';
import { TooltipIconButton } from '@/shared/components/TooltipIconButton';
import { usePaletteMode } from '../../hooks';
import useSsr from './hooks/useSsr';

function ThemeSwitcher(): React.JSX.Element | null {
  const isSsr = useSsr();
  const theme = useTheme();

  const { paletteMode, togglePaletteMode, isDualTheme } = usePaletteMode();

  return isDualTheme ? (
    <TooltipIconButton
      tooltip={
        isSsr
          ? 'Switch mode'
          : `${paletteMode === 'dark' ? 'Light' : 'Dark'} mode`
      }
      aria-label={
        isSsr
          ? 'Switch theme mode'
          : `Switch to ${paletteMode === 'dark' ? 'light' : 'dark'} mode`
      }
      onClick={togglePaletteMode}
      enterDelay={1000}
      sx={{
        color: (theme.vars ?? theme).palette.primary.dark,
        mt: 0.2,
      }}
    >
      <React.Fragment>
        <PiMoon 
          size={20} 
          style={{ display: isSsr || paletteMode !== 'dark' ? 'inline' : 'none' }} 
        />
        <PiSun 
          size={20} 
          style={{ display: isSsr || paletteMode === 'dark' ? 'inline' : 'none' }} 
        />
      </React.Fragment>
    </TooltipIconButton>
  ) : null;
}

export { ThemeSwitcher };

